import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export const getToken = () => {
  //console.log(localStorage.getItem('jwtToken'));
  return localStorage.getItem('jwtToken');
};

export const isMobile = () => {
  return localStorage.getItem('mobile')!=null;
};
 

export const getRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

export const getKeyCert = () => {
  return localStorage.getItem('keyCert');
};
const initialState = {
  token: getToken(),
  refreshToken: getRefreshToken(),
  keyCert: getKeyCert()
};

export const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setToken: (state, action) => {
      localStorage.setItem('jwtToken', action.payload);
      state.token = action.payload;
    },
    setRefreshToken: (state, action) => {
      localStorage.setItem('refreshToken', action.payload);
      state.refreshToken = action.payload;
    },
    setKeyCert: (state, action) => {
      localStorage.setItem('keyCert', action.payload);
      state.keyCert = action.payload;
    },
    removeToken: (state) => {
      localStorage.removeItem('userRole');
      localStorage.removeItem('username');
      localStorage.removeItem('context');
      localStorage.removeItem('contextData');
      localStorage.removeItem('theme');
      localStorage.removeItem('jwtToken');
      localStorage.removeItem('userEmail');
      state.token = null;
    },
    removeRefrshToken: (state) => {
      localStorage.removeItem('refreshToken');
      state.refreshToken = null;
    }
  }
});

export const { setToken, setRefreshToken, setKeyCert,
  removeToken, removeRefrshToken } = tokenSlice.actions;
export const tokenStatus = (state: RootState) => state.token.token;
export const tokenKeyCert = (state: RootState) => state.token.keyCert;
export const refreshTokenStatus = (state: RootState) => state.token.refreshToken;
export default tokenSlice.reducer;
